var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQmeeCloseButton = function SvgQmeeCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F9F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.728 20.365c-.138-.14-.137-.326.004-.464l4.457-4.372-4.371-4.457c-.138-.14-.136-.326.004-.464l.61-.598c.141-.138.303-.114.441.027l4.372 4.457 4.457-4.371c.14-.138.326-.136.464.004l.576.587c.138.14.136.326-.005.464L16.28 15.55l4.371 4.457c.138.14.16.303.02.441l-.61.599c-.141.138-.327.136-.465-.005l-4.372-4.457-4.457 4.371c-.14.138-.326.137-.464-.004z"
  })));
};
export default SvgQmeeCloseButton;